import { OnChangeFn, PaginationState } from "@tanstack/react-table";

import { PAGE_SIZE } from "components";
import { ROLES, USER_STATUSES } from "models";
import { useUsersFilters, useUsersFiltersUpdate } from "modules/Users/hooks";

export const useUsersFilterHandlers = () => {
  const {
    filters: { page: currentPage, page_size: pageSize }
  } = useUsersFilters();
  const usersFiltersUpdate = useUsersFiltersUpdate();

  const onPageChange = (data: { activePage: number }) => usersFiltersUpdate({ page: data.activePage });
  const handlePaginationChange: OnChangeFn<PaginationState> = updater => {
    const newState = typeof updater === "function" ? updater({ pageIndex: currentPage - 1, pageSize }) : updater;
    onPageChange({ activePage: newState.pageIndex + 1 });
  };

  const handlePageSizeChange = (value: PAGE_SIZE) => usersFiltersUpdate({ page_size: value, page: 1 });
  const handleSearchTermChange = (search_term: string) => usersFiltersUpdate({ search_term, page: 1 });
  const handleRoleChange = (role_id: ROLES | null) => usersFiltersUpdate({ role_id, page: 1 });
  const handleStatusChange = (user_status_id: USER_STATUSES | null) => usersFiltersUpdate({ user_status_id, page: 1 });

  return { handlePaginationChange, handlePageSizeChange, handleSearchTermChange, handleRoleChange, handleStatusChange };
};
